__webpack_require__.p = "/cocktail-pwa/";